(function defineCookie($, w) {
    "use strict";

    w.cookie = {
        init: function init() {
            var $cookiesNotification = $(".cookies-save-changes-button");

            $cookiesNotification.find(".accept-cookies").on('click', function acceptCookiesClickHandler() {
                $.cookie('accept-cookies', 'T', { expires: 365, path: '/' });
                $("input.cookies-checkbox").each(function() {
                    $.cookie($(this).attr("name"), $(this).prop('checked'), { path: '/', expires: 365 });
                });
                window.dataLayer360 = window.dataLayer360 || [];
                window.dataLayer360.push({ 'event' : 'consent_mode_updated'});
                $(".cookies-notification-container").fadeOut();
                $(".back-to-top").removeClass("back-to-top-cookies-adjusted");
            });

            var $cookie_selector = $(".cookies-notification-container").css('display') == 'block';
            if($cookie_selector){
                var $cookie_message_container = $(".cookies-message");

                $cookie_message_container.find(".cookie-accept-button").on('click', function acceptCookiesClickHandler() {
                    $.cookie('accept-cookies', 'T', { expires: 365, path: '/' });
                    $.cookie('analytical', true, { expires: 365, path: '/' });
                    $.cookie('marketing', true, { expires: 365, path: '/' });
                    window.dataLayer360 = window.dataLayer360 || [];
                    window.dataLayer360.push({ 'event' : 'consent_mode_updated'});
                    $(".cookies-notification-container").fadeOut();
                    $(".back-to-top").removeClass("back-to-top-cookies-adjusted");
                });

                $(".back-to-top").addClass("back-to-top-cookies-adjusted");
            }
        }
    };
}(window.jQuery, window));

$(document).ready(window.cookie.init);